import React from 'react';
import { reviews } from '../mock';
import { Star, Quote } from 'lucide-react';
import { Card } from './ui/card';

const Reviews = () => {
  return (
    <section id="reviews" className="py-20 bg-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-20 right-0 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl animate-pulse"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="flex items-center justify-center gap-2 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-8 h-8 fill-orange-500 text-orange-500" />
            ))}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            5⭐ <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">Customer Reviews</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Don't just take our word for it - hear from our happy customers!
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((review, index) => (
            <Card
              key={review.id}
              className="group bg-gradient-to-br from-zinc-800/80 to-zinc-900/80 border-zinc-700 hover:border-orange-500 p-6 transform hover:scale-105 hover:-translate-y-2 transition-all duration-500 cursor-pointer relative overflow-hidden"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Quote Icon */}
              <div className="absolute -top-2 -right-2 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote className="w-24 h-24 text-orange-500" />
              </div>
              
              <div className="relative z-10 space-y-4">
                {/* Stars */}
                <div className="flex gap-1">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-orange-500 text-orange-500" />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-300 leading-relaxed text-sm">
                  "{review.text}"
                </p>

                {/* Reviewer Info */}
                <div className="pt-4 border-t border-zinc-700">
                  <p className="font-bold text-white">{review.name}</p>
                  <p className="text-sm text-gray-500">{review.date}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Review Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { label: 'Happy Customers', value: '150+' },
            { label: 'Average Rating', value: '5.0' },
            { label: 'Years Experience', value: '5+' },
            { label: 'Vehicles Detailed', value: '500+' }
          ].map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 bg-zinc-800/50 rounded-xl border border-zinc-700 hover:border-orange-500 transform hover:scale-105 transition-all duration-300"
            >
              <div className="text-4xl font-bold bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent mb-2">
                {stat.value}
              </div>
              <div className="text-gray-400 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
